import { Input, Component, OnInit } from '@angular/core';
import {IngredientService} from "../../../services/ingredient.service";

@Component({
    selector: 'ingredient-list',
    templateUrl: './ingredient-list.component.html'
})
export class IngredientListComponent implements OnInit {
    @Input() ingredients: Object[] = null;
    public activeObject;
    public activeObjectId: string = null;
    encodeURIComponent = encodeURIComponent;
    public inciTooltipText: string = 'INCI is de afkorting van International Nomenclature Cosmetic Ingredients. Vanaf 1 januari 1996 is elke fabrikant van cosmetische producten verplicht om de verwerkte ingrediënten op de verpakking te vermelden. Over de manier waarop dit dient te gebeuren zijn internationale afspraken gemaakt, zodat in ieder geval in de USA en in Europa ingrediënten dezelfde namen hebben en als zodanig herkenbaar zijn voor de consument. Deze namen zijn geregistreerd door de INCI. De namen die op de verpakking terug te vinden zijn, zijn in de meeste gevallen INCI namen. Wanneer een ingrediënt geregistreerd is door de INCI betekent dat niet automatisch dat een ingrediënt goed voor de huid is. De INCI is neutraal.<br><br><a href="/inci">Lees meer over INCI</a>';
    public scoreTooltipText: string = 'Per cosmetische ingrediënt wordt een indicatie afgegeven. Groen (10-6) geeft aan dat het ingrediënt (grote) concentraties van stoffen bevat die identiek zijn aan de menselijke huid of het menselijk lichaam en om deze reden huidvriendelijk zijn. Oranje (6-5) betekent dat het ingrediënt weinig of geen invloed op de menselijke huid heeft en zelfs minder huidvriendelijk kan zijn.<br>Rood met een indicatie van 5-4 geeft aan elk ingrediënt dat omwille van het product aan het product wordt toegevoegd, maar dat geen nut heeft voor de huid of zelfs huidonvriendelijk kan zijn. Het kan ook betekenen dat het ingrediënt geen bewezen voordeel voor de huid heeft. De indicatie 4 en lager geeft aan dat ingrediënt een negatief effect op de huid, gezondheid en het lichaam kan hebben.';
    constructor(private ingredientService: IngredientService) { }

    ngOnInit() { }

    setActive(id)
    {
        this.activeObject = null;
        if(this.activeObjectId == id)
        {
            this.activeObjectId = null;
        }
        else
        {
            this.activeObjectId = id;
            this.ingredientService.get(this.activeObjectId).subscribe((res) => {
                this.activeObject = res.data;
            });
        }
    }
}



// WEBPACK FOOTER //
// D:/Documents/FTP/derma/dermabase.nl_backup/src/app/frontend/_blocks/ingredient-list/ingredient-list.component.ts